import React from "react";
import "./ReportData.css";

function TypeDate({ setTypeDate, typeDate }) {
  const handleChange = (e) => {
    const value = e.target.name;
    setTypeDate(typeDate === value ? "" : value);
  };

  return (
    <div className="main-data-1">
      <div className="category">
        <p>Download Tnx By :-</p>
      </div>

      <div className="category">
        <span>Created At</span>
        <input
          type="checkbox"
          name="createdAt"
          checked={typeDate === "createdAt"}
          onChange={handleChange}
        />
      </div>

      <div className="category">
        <span>Updated At</span>
        <input
          type="checkbox"
          name="updatedAt"
          checked={typeDate === "updatedAt"}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default TypeDate;